import { createReducer } from "sc/helpers/reducer";
import { CITIES_LOADED } from "../actions/cities";
import { LOCATION_CHANGE } from "react-router-redux/reducer";

export default createReducer(null, {
  [LOCATION_CHANGE]: (state, action) => null,
  [CITIES_LOADED]: (state, action) => action.payload.cities,
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/cities-reducer.js